import { getCurrentOrg } from './getCurrentOrg';
import { ConversationApiService } from '../services/conversations';

export const getConversation = (id: string) => {
  return ConversationApiService.getConversation1(id, getCurrentOrg());
};

export const getConversationAudio = (id: string) => {
  return ConversationApiService.getAudioFiles(id);
};

export type { ConversationAudioFile } from '../services/conversations';
export type { ConversationDto as ConversationType } from '../services/conversations';
